/* eslint-disable vue/one-component-per-file */
import Vue from 'vue';
import store from '../../store';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import ProgressButton from '@/shared/ProgressButton.vue';

const RECAPTCHA_SITE_KEY = store.getters['auth/getRecaptchaSiteKey'];

Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_SITE_KEY });
Vue.component('GotedoSpinnerLoader', () => import('../spinners/GotedoSpinnerLoader.vue'));
Vue.component('CustomAlert', () => import('../CustomAlert.vue'));
Vue.component('GotedoList', () => import('../GotedoList.vue'));
Vue.component('GotedoBadge', () => import('../GotedoBadge.vue'));
Vue.component('GotedoDropdown', () => import('../GotedoDropdown.vue'));
Vue.component('GotedoDialog', () => import('../GotedoDialog'));
Vue.component('GotedoEmptyState', () => import('../GotedoEmptyState.vue'));
Vue.component('GotedoCheckbox', () => import('../GotedoCheckbox.vue'));
Vue.component('GotedoSelect', () => import('../GotedoSelect'));
Vue.component('GotedoLabel', () => import('../GotedoLabel'));
Vue.component('GotedoTable', () => import('../GotedoTable.vue'));
Vue.component('GotedoAvatar', () => import('../GotedoAvatar.vue'));
Vue.component('GotedoPhoneNumberInput', () => import('../GotedoPhoneNumberInput'));
Vue.component('DeleteConfirmationModal', () => import('../DeleteConfirmationModal'));
Vue.component('AdminAreaForm', () => import('../../containers/AdminAreaForm.vue'));
Vue.component('AdminDetailsLayout', () => import('../../containers/AdminDetailsLayout.vue'));
Vue.component('UserProfileStatusComponent', () =>
  import('../../shared/vue-table-components/UserProfileStatusComponent.vue')
);
Vue.component('VueTableGenderComponent', () =>
  import('../../shared/vue-table-components/VueTableGenderComponent.vue')
);
Vue.component('MemberFullNameNAvatar', () =>
  import('../../shared/vue-table-components/MemberFullNameNAvatar.vue')
);
Vue.component('ProgressButton', ProgressButton);
Vue.component('HandHoldingHeartIcon', () => import('../icon_components/hand_holding_heart.vue'));
Vue.component('HandPhoneIcon', () => import('../icon_components/hold_phone.vue'));
Vue.component('LegalIcon', () => import('../icon_components/legal_icon.vue'));
Vue.component('GotedoImage', () => import('../GotedoImage.vue'));
Vue.component('ColumnTextComponent', () =>
  import('../vue-table-components/ColumnTextComponent.vue')
);
Vue.component('ColumnBadgeComponent', () =>
  import('../../shared/vue-table-components/ColumnBadgeComponent.vue')
);
Vue.component('GotedoEditor', () => import('../../shared/components/GotedoEditor.vue'));
